import router from './router'
import app from './store/app'
import { getCookie,setCookie } from '@/utils/auth'
import API from './api'
// import wx from './utils/WXUntil'
import {UrlSearch} from "@/utils/fu";

console.log(location.href)

let href = new UrlSearch();
let shopId = 0;
if (href.shopId) {
    shopId = href.shopId;
    setCookie('shopId', shopId)
}
if (href.shop_id) {
    shopId = href.shop_id;
    setCookie('shopId', shopId)
}
let time = Math.round(new Date().getTime()/1000)
if (href.number) {
    setCookie('shop_number_' + shopId, href.number)
    setCookie('shop_number_time_' + shopId, time)
}

let shop_number_time = getCookie('shop_number_time_' + shopId)
if (shop_number_time !== 'undefined' && shop_number_time !== '') {
    shop_number_time = parseInt(shop_number_time)
    if ((shop_number_time + 60 * 30) < time) {
        setCookie('shop_number_' + shopId, 0)
        setCookie('shop_number_time_' + shopId, 0)
    }
} else {
    setCookie('shop_number_' + shopId, 0)
    setCookie('shop_number_time_' + shopId, 0)
}

if (href.coType) {
    setCookie('coType', href.coType)
} else {
    let coType = getCookie('coType')
    if (!coType) {
        setCookie('coType', 2)
    }
}

// import VueRouter from 'vue-router'

router.beforeEach(async (to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }

    let token = getCookie('token')
    if (!token) {
        if (to.path !== '/order_success' && to.path !== '/' && to.path !== '/location' && to.path !== '/shop'
            && to.path !== '/auth' && to.path !== '/address' && to.path !== '/userAddress'
        ) {
            let code = app.mutations.getUrl('code')
            if (code) {
                API.getThird({
                    'type': 1,
                    'platform': 'wechat',
                    'code': code
                }).then(res => {
                    // wx.wxJsSdkInit()
                    return res;
                }).then((res) => {
                    setCookie('userInfo', JSON.stringify(res.data.data.userinfo))
                    setCookie('token', res.data.data.userinfo.token)
                    let cache_url = getCookie('cache_url')
                    if (cache_url) {
                        next(cache_url)
                    } else {
                        next();
                    }

                })
            } else {
                setCookie('cache_url', location.pathname + location.search)
                next()
                // if (to.path !== '/auth') {
                //     next({
                //         path: '/auth'
                //     })
                // } else {
                //     next()
                // }
            }
        } else {
            let code = app.mutations.getUrl('code')
            if (code) {
                API.getThird({
                    'type': 1,
                    'platform': 'wechat',
                    'code': code
                }).then(res => {
                    // wx.wxJsSdkInit()
                    return res;
                }).then((res) => {
                    setCookie('userInfo', JSON.stringify(res.data.data.userinfo))
                    setCookie('token', res.data.data.userinfo.token)
                    let cache_url = getCookie('cache_url')
                    if (cache_url) {
                        next(cache_url)
                    } else {
                        next();
                    }

                })
            } else {
                next()
            }
        }
    } else {
        next()
    }

})
